<template>
    <div v-if="group.users.length > 0 && $canView('superadministrador','administrador','administradorevento')">
      <table class="min-w-full divide-y divide-gray-200">
        <thead class="bg-gray-200">
          <tr>
            <th class="px-4 py-2 text-center text-xs font-medium text-gray-600 uppercase">{{ uiT('moderators.name') }}</th>
            <th class="px-4 py-2 text-center text-xs font-medium text-gray-600 uppercase">{{ uiT('moderators.email') }}</th>
            <th v-if="!fechaCorte" class="px-4 py-2 text-center text-xs font-medium text-gray-600 uppercase">{{ uiT('moderators.actions') }}</th>
          </tr>
        </thead>
        <tbody class="bg-white divide-y divide-gray-300">
          <tr v-for="user in group.users" :key="user.id">
            <td class="px-4 py-2">{{ user.nombre }}</td>
            <td class="px-4 py-2">{{ user.email }}</td>
            <td class="px-4 py-2" v-if="!fechaCorte && grupo_activo == 1">
                <a
                v-if="$canView('superadministrador','administradorevento')" 
                :href="`/api/ticket/${user.id_token}/${group.group_id}`"
                target="_blank"
                class="inline-block mt-2 px-4 mr-2  bg-blue-600 hover:bg-blue-800 text-white rounded"
                style="    padding-top: 4px;
    padding-bottom: 4px;"
              >
                {{ uiT('moderators.accessTicket') }}
              </a>
              <EnvioMagicLinkUsuario v-if="$canView('superadministrador','administradorevento','administrador')" :tokenUsuario="user.id_token" :groupToken="group.group_id"/>
              <button @click="editUser(user.id_token)" class="bg-blue-500 hover:bg-blue-700 text-white font-bold py-1 px-3 rounded">{{ uiT('common.edit') }}</button>
              <button @click="deleteUser(user.id_token, group.group_id)" class="ml-2 button-clear">{{ uiT('common.delete') }}</button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <div v-else class="text-center py-2">
      <span v-if="$canView('superadministrador','administrador')">{{ uiT('moderators.none') }}</span>
    </div>
</template>
  
<script>
import axios from 'axios';
import { useToast } from "vue-toastification";
import EnvioMagicLinkUsuario from '@/components/administracion/EnvioMagicLinkUsuario.vue';
import { userManagementI18nMixin } from "../i18n/userManagementI18n.js";
export default {
  mixins: [userManagementI18nMixin],
  props: {
    group: {
      type: Object,
      required: true,
    },
    fechaCorte: Boolean,
    grupo_activo: String
    // token: {
    //   type: String,
    //   required: true
    // }
  },
  components: {
    EnvioMagicLinkUsuario
  },
  setup() {
    const toast = useToast();
    return { toast };
  },
  data() {
        return {
            localFechaCorte: this.fechaCorte,
        };
    },


  methods: {
    editUser(userId) {
      const url = `/dashboard/user/edit/${userId}`;
      window.open(url, '_blank');
    },
    deleteUser(userId, groupId) {
    const token = this.$store.state.user.token;
      axios.post(`/api/user/delete/${userId}`, { grupo: groupId, Authorization: `${token}` })
      .then(response => {
        if (response.data && response.data.success) {
          this.toast.success(response.data.success);
          this.$emit('user-deleted', { userId, groupId }); // Emitir ambos IDs
        } else {
          this.toast.warning(this.uiT('moderators.deletedWarning'));
        }
      })
      .catch(error => {
        console.error("Error al eliminar usuario:", error);
        let errorMessage = this.uiT('moderators.deleteError');
        if (error.response && error.response.data) {
          errorMessage = error.response.data.error || error.response.data.message || errorMessage;
        } else {
          errorMessage = error.message || errorMessage;
        }
        this.toast.error(errorMessage);
      });
    },
  }
}
</script>

  <style lang="sass" scoped>
  
  
.button-clear 
    min-width: 20px
    background-color: #f94e3b
    color: white
    padding: 4px 0.5rem
    border-radius: 0.375rem
    display: inline-flex
    align-items: center
    justify-content: center
    transition: background-color 0.15s ease-in-out


.button-clear:hover 
    background-color: #be0303

  </style>
